@if (isPageLoading() === false) {
  @if (model(); as model) {
    <div class="resource">
      <div class="resource-header">
        <div class="resource-header-title">
          <div class="resource-header-title-text" style="display: flex" appLongTextTooltip>
            {{ model.displayName }}

            @if (errorMessage()) {
              <img
                class="status-label-icon"
                src="assets/images/status-icons/error.svg"
                alt="Error"
                [matTooltip]="errorMessage()"
                style="padding-top: 3px"
              />
            }
          </div>
        </div>

        <div class="resource-header-secondary-title">
          <div class="resource-header-secondary-title-property">
            <div>
              {{ 'Inventory Resource: ' + (model.resourceType | resourceTypeDisplayName) }}
            </div>
          </div>
          <div class="separator">|</div>
          <div class="resource-header-secondary-title-property">
            <div>
              {{ 'inventoryResourcePage.idTitle' | labelsProvider }}
            </div>
            <app-copy-button class="copy-button" [value]="model.id" [title]="model.id" [isSecondaryFontColor]="true">
            </app-copy-button>
          </div>
        </div>

        <div class="resource-header-tertiary-title">
          <div class="resource-header-tertiary-title-property">
            <div>
              {{ 'inventoryResourcePage.statusTitle' | labelsProvider }}
            </div>
            <app-status-label
              [statusLabel]="statusLabel()"
              [matTooltip]="statusLabelReason()"
              matTooltipPosition="right"
              matTooltipClass="tooltip-container"
            ></app-status-label>
          </div>
        </div>

        @if (model.platformInfo.lastRefreshed) {
          <div class="resource-header-quaternary-title">
            <div class="resource-header-quaternary-title-property last-refreshed">
              <div>
                {{
                  ('inventoryResourcePage.lastRefreshedTitle' | labelsProvider) +
                    ' ' +
                    (model.platformInfo.lastRefreshed | date: 'MMM d,y,HH:mm')
                }}
              </div>
              <div class="info-icon">
                <img
                  src="assets/images/common/info.svg"
                  width="14"
                  [matTooltip]="'inventoryResourcePage.lastRefreshedTooltip' | labelsProvider"
                  matTooltipPosition="right"
                  matTooltipClass="tooltip__white tooltip__multiline"
                />
              </div>
              @if (model.refreshMethod === RefreshMethodEnum.eventDriven) {
                <div class="lightning-icon">
                  <img
                    src="assets/images/common/lightning.svg"
                    width="20"
                    [matTooltip]="'inventoryResourcePage.lightningTooltip' | labelsProvider"
                    matTooltipPosition="right"
                    matTooltipClass="tooltip__white tooltip__multiline"
                  />
                </div>
              }
            </div>
          </div>
        }

        <app-sidepanel-tabs class="resource-header-tabs" [tabs]="tabs()" (tabOnSelection)="onTabSelect($event)">
        </app-sidepanel-tabs>
      </div>

      @if (activeTabIndex() === 0) {
        <div class="resource-actions">
          @if (isActionRunningSpinner()) {
            <mat-progress-spinner
              class="small-spinner"
              color="primary"
              mode="indeterminate"
              style="left: -20px"
            ></mat-progress-spinner>
          }

          <div class="actions">
            <app-single-page-actions
              class="actions"
              [menuActions]="menuActions()"
              (actionSelected)="actionSelected($event)"
            ></app-single-page-actions>
          </div>
        </div>
      }

      <div class="resource-body">
        @if (activeTabIndex() === 0) {
          <div class="resource-body-tab">
            <div class="resource-body-tab-card info-card">
              <div class="resource-body-tab-card-title">
                {{ 'inventoryResourcePage.infoCardGraphTitle' | labelsProvider }}
              </div>
              <app-relations-graph
                [integrationId]="integration()"
                [resourceId]="resource()"
                [relatedResourcesSummary]="relatedResourcesSummary()"
              ></app-relations-graph>
            </div>

            @if (identitiesCardFields().length > 0) {
              <div class="resource-body-tab-card info-card">
                <div class="resource-body-tab-card-title">
                  Identities
                </div>
                <app-card-fields
                  [cardFields]="identitiesCardFields()"
                  [isToggleContentAllowed]="false"
                ></app-card-fields>
              </div>
            }

            <div class="resource-body-tab-card info-card">
              <div class="resource-body-tab-card-title">
                {{ 'inventoryResourcePage.infoCardTitle' | labelsProvider }}
              </div>
              <app-card-fields
                [cardFields]="infoCardFields()"
                [resourceType]="model.resourceType"
                [resourceCategory]="model.resourceCategory"
                [isToggleContentAllowed]="true"
              ></app-card-fields>

              @if (isLinkDisabled() === false) {
                @if (
                  model.platformInfo.urls.status === InventoryEntityFieldStatusEnum.hasValue &&
                  model.platformInfo.urls.value?.webAppUrl?.status === InventoryEntityFieldStatusEnum.hasValue
                ) {
                  <app-anchor-link [navigation]="model.platformInfo.urls.value?.webAppUrl?.value ?? ''">
                    <img src="assets/images/common/link.svg" class="explore-resource-link__icon" />
                    {{ 'inventoryResourcePage.environmentPlatformLink' | labelsProvider }}
                  </app-anchor-link>
                }
              } @else {
                <app-anchor-link navigation="" [disabled]="true" matTooltip="{{ this.linkDisabledTooltip }}">
                  {{ 'inventoryResourcePage.environmentPlatformLink' | labelsProvider }}
                </app-anchor-link>
              }

              @if (agentLink(); as link) {
                <span [matTooltip]="isAgentLinkDisabled() ? agentLinkDisabledTooltip() : ''" matTooltipPosition="right">
                  <app-anchor-link [navigation]="link" [disabled]="isAgentLinkDisabled()">
                    <img src="assets/images/common/link.svg" class="explore-resource-link__icon" />
                    {{ 'inventoryResourcePage.viewRuntimeActivity' | labelsProvider }}
                  </app-anchor-link>
                </span>
              }
            </div>

            @if (additionalInfoCardFields().length > 0) {
              <div class="resource-body-tab-card additional-info-card">
                <app-accordion
                  class="resource-body-tab-card-title"
                  accordionTitle="inventoryResourcePage.additionalInfoCardTitle"
                  [boldTitle]="true"
                  [withLabelPipe]="true"
                  [expanded]="isAdditionalInfoBlockExpanded()"
                  (accordionExpansionEvent)="updateResourceBodyAccordionExpansionState($event)"
                >
                  <app-card-fields
                    [cardFields]="additionalInfoCardFields()"
                    [resourceType]="model.resourceType"
                    [isToggleContentAllowed]="true"
                  ></app-card-fields>
                </app-accordion>
              </div>
            }

            <div class="resource-body-tab-card environment-card">
              <div class="resource-body-tab-card-title">
                {{ 'inventoryResourcePage.environmentCardTitle' | labelsProvider }}
              </div>
              <app-card-fields [cardFields]="environmentCardFields()" [isToggleContentAllowed]="true"></app-card-fields>
            </div>

            @if (generativeAiPropertiesCardFields().length > 0) {
              <div class="resource-body-tab-card generative-ai-card">
                <div class="resource-body-tab-card-title-container">
                  <img class="resource-body-tab-card-title-container-icon" src="assets/images/common/robot.svg" />
                  <div class="resource-body-tab-card-title">
                    {{ 'inventoryResourcePage.generativeAiCardTitle' | labelsProvider }}
                  </div>
                </div>
                <app-card-fields
                  [cardFields]="generativeAiPropertiesCardFields()"
                  [isToggleContentAllowed]="true"
                ></app-card-fields>
              </div>
            }

            <div class="resource-body-tab-card timeline-card">
              <div class="resource-body-tab-card-title">
                {{ 'inventoryResourcePage.timelineCardTitle' | labelsProvider }}
              </div>
              <app-timeline [timelineItems]="timelineItems()" [withIcons]="true"></app-timeline>
            </div>
          </div>
        }

        @if (activeTabIndex() === 1) {
          @if (isRelationsTabLoading() === false) {
            @if (relatedResourcesCardsInputs().length > 0) {
              <div class="resource-body-tab">
                <div class="resource-inventory-body-subtitle resource-relations" (click)="navigateToRelatedResources()">
                  <img src="assets/images/common/link.svg" />
                  {{
                    ('inventoryResourcePage.resourcesRelationsCardsTitle' | labelsProvider) +
                      ' (' +
                      totalRelatedResources() +
                      ')'
                  }}
                </div>

                <div class="resource-inventory-body-subtitle">
                  {{ sampleRelatedResourcesDisclaimer() }}
                </div>

                @if (resourceCategoryFilters().length >= 1) {
                  <div class="resource-filters-section">
                    <div class="resource-secondary-title">
                      {{ 'inventoryResourcePage.filterBy' | labelsProvider }}
                    </div>
                    <div class="resource-filters-container">
                      <app-filter-chips
                        [options]="resourceCategoryFilters()"
                        (chipOnSelection)="changeCategoriesFilters($event)"
                      ></app-filter-chips>
                    </div>
                  </div>
                }

                @for (input of relatedResourcesCardsInputs(); track $index) {
                  <app-related-resource-card
                    [parentInput]="input"
                    [hidden]="!input.isVisible"
                    [isToggleContentAllowed]="true"
                  >
                  </app-related-resource-card>
                }
              </div>
            } @else {
              <app-no-data> </app-no-data>
            }
          } @else {
            <div class="spinner">
              <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
            </div>
          }
        }

        @if (activeTabIndex() === 2) {
          @if (isViolationsTabLoading() === false) {
            @if (relatedViolationsCardsInputs().length > 0) {
              <div class="resource-body-tab">
                <a
                  class="resource-violations-link"
                  [href]="violationsPageUrl()"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{
                    ('inventoryResourcePage.resourceViolationsCardsTitle' | labelsProvider) +
                      ' (' +
                      relatedViolationsCardsInputs().length +
                      ')'
                  }}
                  <lucide-icon name="external-link" class="resource-violations-link__icon" [size]="14"></lucide-icon>
                </a>

                @for (input of relatedViolationsCardsInputs(); track $index) {
                  <app-related-violation-card
                    [input]="input"
                    [isToggleContentAllowed]="true"
                  ></app-related-violation-card>
                }
              </div>
            } @else {
              <app-no-data> </app-no-data>
            }
          } @else {
            <div class="spinner">
              <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
            </div>
          }
        }

        @if (activeTabIndex() === 3) {
          @if (isHygieneTabLoading() === false) {
            @if (relatedHygieneCardsInputs().length > 0) {
              <div class="resource-body-tab">
                <div>
                  {{
                    ('inventoryResourcePage.resourceHygieneCardsTitle' | labelsProvider) +
                      ' (' +
                      relatedHygieneCardsInputs().length +
                      ')'
                  }}
                </div>

                @for (input of relatedHygieneCardsInputs(); track $index) {
                  <app-related-violation-card
                    [input]="input"
                    [isToggleContentAllowed]="true"
                  ></app-related-violation-card>
                }
              </div>
            } @else {
              <app-no-data> </app-no-data>
            }
          } @else {
            <div class="spinner">
              <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
            </div>
          }
        }
      </div>
    </div>
  }
} @else {
  <div class="spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
}
